/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_kyc_gate_banner_description = /** @type {(inputs: {}) => string} */ () => {
	return `Completa una verificación rápida para acceder a tarjetas, cuentas, transferencias y más.`
};

const en_kyc_gate_banner_description = /** @type {(inputs: {}) => string} */ () => {
	return `Complete a quick identity check to access cards, accounts, transfers, and more.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const kyc_gate_banner_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.kyc_gate_banner_description(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("kyc_gate_banner_description", locale)
	if (locale === "es") return es_kyc_gate_banner_description(inputs)
	return en_kyc_gate_banner_description(inputs)
};
export { kyc_gate_banner_description as "kyc_gate.banner_description" }